/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_SubtitleInputs */

const cs_gdpr_subtitle = /** @type {(inputs: Gdpr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export a výmaz osobních údajů, přehled přístupů a změn.`)
};

const en_gdpr_subtitle = /** @type {(inputs: Gdpr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export and erasure of personal data, access and change log.`)
};

/**
* | output |
* | --- |
* | "Export and erasure of personal data, access and change log." |
*
* @param {Gdpr_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_subtitle = /** @type {((inputs?: Gdpr_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_subtitle(inputs)
	return cs_gdpr_subtitle(inputs)
});